var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.7352 10.592C2.88372 11.1185 0.651186 12.1936 2.01095 13.5389C2.67518 14.196 3.41497 14.666 4.34505 14.666H9.65234C10.5824 14.666 11.3222 14.196 11.9864 13.5389C13.3462 12.1936 11.1137 11.1185 10.2622 10.592C8.26548 9.35735 5.73191 9.35735 3.7352 10.592Z",
    stroke: "#101928",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.91536 4.24967C9.91536 5.86051 8.60953 7.16634 6.9987 7.16634C5.38787 7.16634 4.08203 5.86051 4.08203 4.24967C4.08203 2.63884 5.38787 1.33301 6.9987 1.33301C8.60953 1.33301 9.91536 2.63884 9.91536 4.24967Z",
    stroke: "#101928",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.bdc47a5dd7e886c1e4b86d0a3fea1c58.svg";
export { ForwardRef as ReactComponent };